import {AbstractCommand} from "./abstract.command";
import {CommandName} from "./command-name.enum";

/**
 * The per-tenant translation override set: a flat map of dotted i18n key to its
 * override text (empty overrides already stripped by the editor). This IS the
 * command payload — a plain `Record<string,string>`, not a proxified entity.
 */
export type TranslationOverridePayload = Record<string, string>;

/**
 * Command to persist a tenant's full translation override set (O2D-PRD-092).
 * Mirrors the backend `save.translation-override` command (O2D-PRD-090,
 * `backend/src/Command/CommandInterface.php:66`) and follows the entity-less,
 * plain-value-payload precedent `SaveKnowledgeObjectContentCommand`.
 *
 * A translation override has no entity/uid, so `mainEntityClass` is the synthetic
 * marker `'translation-override'` and `mainEntityUid` is the tenant string. The
 * payload is the full override set across all segments (a full-set write).
 *
 * The class name MUST stay exactly `SaveTranslationOverrideCommand` — the
 * command-to-dto transformer is looked up by the kebab-cased class name
 * (`transformer.save-translation-override-command_dto`,
 * `transformer.helper.ts:30-34`); any other name misses the lookup and the
 * generic fallback throws at runtime for the non-proxy payload.
 */
export class SaveTranslationOverrideCommand extends AbstractCommand<TranslationOverridePayload> {

    public name: CommandName = CommandName.SAVE_TRANSLATION_OVERRIDE;

    public tags = ['translation-override', 'save'];

    constructor(tenant: string, payload: TranslationOverridePayload) {
        super('translation-override', tenant, payload);
    }

}
